import LegalShell from "../components/LegalShell";

export default function Terms() {
    return (
        <LegalShell title="Terms of Use" updated="25 Feb 2026">
            <p>
                Welcome to Vowze — an AI-assisted wedding-look planning tool that generates a
                Couple Colour Palette, an editorial photo gallery and an event-styling brief from
                photos you upload. By using Vowze you agree to the terms below. Please read
                them carefully.
            </p>

            <h2>1. What Vowze is (and what it isn&apos;t)</h2>
            <ul>
                <li>Vowze produces AI-generated visual and text recommendations for reference and inspiration only.</li>
                <li>Vowze is <strong>not</strong> a legal, medical, matrimonial, or financial advisory service.</li>
                <li>The AI-rendered images are illustrative; real-life outcomes depend on your stylist,
                    photographer, venue and outfit choices.</li>
            </ul>

            <h2>2. Photos you upload</h2>
            <ul>
                <li>You confirm every uploaded photo is of you and/or your partner and that both
                    people pictured have consented to their photos being used to generate this report.</li>
                <li>You will not upload photos of minors, strangers, celebrities, or anyone who has
                    not given you clear, informed consent.</li>
                <li>You are solely responsible for the legality of the photos you upload. Vowze may
                    delete any report at any time if we believe this term has been breached.</li>
            </ul>

            <h2>3. AI accuracy disclaimer</h2>
            <p>
                Vowze uses third-party AI models. AI-generated outputs may contain inaccuracies,
                misinterpretations or unintended likenesses. The reports and images are provided
                <em> &ldquo;as is&rdquo;</em>, without warranty of any kind. Use them as inspiration — not as
                a guarantee of a specific look, colour match or wedding outcome.
            </p>

            <h2>4. Payments &amp; refunds</h2>
            <ul>
                <li>Paid unlocks are charged in Indian Rupees via Razorpay.</li>
                <li>Because reports are generated on-demand using paid AI compute, purchases are
                    <strong> non-refundable</strong> once generation has begun.</li>
                <li>If a report never completes due to a Vowze-side technical failure, contact us
                    at support@vowze.app for a manual review and refund.</li>
            </ul>

            <h2>5. Intellectual property</h2>
            <ul>
                <li>You retain full ownership of the photos you upload.</li>
                <li>You are granted a personal, non-transferable licence to use the generated
                    report and images for planning your own wedding.</li>
                <li>Vowze retains ownership of the platform, prompts, decision engine and brand.</li>
            </ul>

            <h2>6. Prohibited use</h2>
            <ul>
                <li>You will not use Vowze to impersonate anyone.</li>
                <li>You will not use Vowze to generate imagery that is defamatory, deceptive, obscene, or
                    intended to harm any person.</li>
                <li>You will not attempt to reverse-engineer, scrape, or resell Vowze&apos;s outputs.</li>
            </ul>

            <h2>7. Termination</h2>
            <p>
                We may suspend or terminate access if we believe these terms have been breached, or
                to protect the platform or other users. You may request deletion of your data at
                any time by writing to <a href="mailto:support@vowze.app">support@vowze.app</a>.
            </p>

            <h2>8. Governing law</h2>
            <p>
                These terms are governed by the laws of India. Any disputes will be subject to the
                exclusive jurisdiction of the courts of Bengaluru, Karnataka.
            </p>

            <h2>9. Contact</h2>
            <p>
                Questions? Write to <a href="mailto:support@vowze.app">support@vowze.app</a>.
            </p>
        </LegalShell>
    );
}
